import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

interface PlanCardFeatureItemProps {
  text: string;
  color: string;
}

export function PlanCardFeatureItem({ text, color }: PlanCardFeatureItemProps) {
  return (
    <ListItem dense sx={{ px: 0 }}>
      <ListItemIcon sx={{ pr: 1, minWidth: 2 }}>
        <CheckCircleIcon sx={{ color }} />
      </ListItemIcon>

      <ListItemText>{text}</ListItemText>
    </ListItem>
  );
}
